import { Routes, RouterModule } from '@angular/router';
import { AddCategoryComponent } from './add-category.component';

const AddCategoryRoutes: Routes = [
  {
    path: '',
    component: AddCategoryComponent,
  },
];

export const MAIN_ADDCATEGORY = RouterModule.forChild(AddCategoryRoutes);
